import React, { PureComponent, Fragment } from "react";
import { connect } from "react-redux";
import $ from "jquery";
import _ from "lodash";
import EventForm from "./EventFormContainer";
import MapContainer from "../map/map.container.google";
import { Calendar } from "fullcalendar";
import { Modal, Button, DatePicker, Spin } from "antd";
import moment from "moment-timezone";
import "moment/locale/fr";
import { isJourFerie } from "./Calendar.util";
import {
  sendUpdatedEvent,
  sendNewEvent,
  moveDayEvents,
  fetchEventTypesList,
  fetchtypesVisitList,
  setPlanningSelectedDate
} from "./../../../redux/actions/planningActions";

import {
  isVacationPending,
  isVacationRejected,
  isVacationValidated,
  computeIfIsVacation,
  isDurationLowerThan45Min,
  isVisited,
  isPlaned,
  isNotPlanned,
  isNotVisited,
  getMinTime,
  getMaxTime,
  isSpeedyOrAdmin
} from "./Calendar.utils";

import ModalComponent from "../../../components/modalComponent/ModalComponent";

import { selectUserInfos, selectUserRoleId } from "../../../redux/selectors/user";
import { roles } from "../../../configs/constants";
import { selectPresenceSelectedUserVacations } from "../../../redux/selectors/presenceSelector";
import {
  selectEvents,
  selectLuccaVacationDays,
  selectPlanningDate,
  selectPlanningEmail
} from "../../../redux/selectors/planningSelector";

const LUCCA_VACATION_DAY_CLASS = "fc-lucca-vacation";
const LUCCA_VACATION_EVENT_CLASS = "fc-lucca-vacation-event";
const LUCCA_VACATION_EVENT_TITLE = "Congé Lucca";
const LUCCA_VACATION_EVENT_START_HOUR = 9;
const LUCCA_VACATION_EVENT_END_HOUR = 17;

const isLuccaVacationEvent = event => event && event.isLuccaVacation;

const getLuccaVacationEvents = (vacationDays = []) => {
  return vacationDays
    .filter(vacationDay => vacationDay && vacationDay.date)
    .map((vacationDay, index) => {
      const date = moment(vacationDay.date).format("YYYY-MM-DD");
      const start = moment(date)
        .hour(LUCCA_VACATION_EVENT_START_HOUR)
        .minute(0)
        .second(0)
        .millisecond(0);
      const end = moment(date)
        .hour(LUCCA_VACATION_EVENT_END_HOUR)
        .minute(0)
        .second(0)
        .millisecond(0);

      return {
        id: `lucca-vacation-${date}-${index}`,
        _id: `lucca-vacation-${date}-${index}`,
        title: LUCCA_VACATION_EVENT_TITLE,
        start,
        end,
        start_date: start.format(),
        end_date: end.format(),
        editable: false,
        startEditable: false,
        durationEditable: false,
        isLuccaVacation: true,
        luccaVacationDay: vacationDay,
        className: [LUCCA_VACATION_EVENT_CLASS]
      };
    });
};

class FullCalendar extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      visibleCreationModal: false,
      isAbsenceModalVisible: false,
      updateEventFromCalendarClick: false,
      createFromCalendarClick: false,
      eventInfos: {},
      requestResponseModal: {},
      calendarView: "agendaWeek",
      visibleMoveDayModal: false,
      moveSourceDate: undefined,
      moveTargetDate: undefined,
      isMovingDayEvents: false
    };
  }

  componentDidMount() {
    this.updateEvents();
    this.props.fetchtypesVisitList();
    this.props.getEventTypesList();
  }

  componentDidUpdate(prevProps) {
    const didPlanningEventsChange =
      JSON.stringify(prevProps.events.filter(e => e.author)) !== JSON.stringify(this.props.events.filter(e => e.author));
    const didLuccaVacationDaysChange =
      JSON.stringify(prevProps.luccaVacationDays) !== JSON.stringify(this.props.luccaVacationDays);

    if (didPlanningEventsChange || didLuccaVacationDaysChange) {
      this.updateEvents();
    }
    if (this.state.isMovingDayEvents && prevProps.modalIsLoading && !this.props.modalIsLoading) {
      if (this.props.requestResponse && this.props.requestResponse.status === 1) {
        this.setState({
          visibleMoveDayModal: false,
          moveSourceDate: undefined,
          moveTargetDate: undefined,
          isMovingDayEvents: false
        });
      } else {
        this.setState({ isMovingDayEvents: false });
      }
    }
  }

  getEventType = (element, type) => {
    type === "teleponique"
      ? element.find(".fc-title").prepend('<span class="p-calendar-event-ico icon-phone"></span> ')
      : null;
    type === "Speedy"
      ? element.find(".fc-title").prepend('<span class="p-calendar-event-ico icon-car"></span> ')
      : null;
    type === "boxe" ? element.find(".fc-title").prepend('<span class="p-calendar-event-ico icon-box"></span> ') : null;
    return;
  };

  getMovableEventsOfDay = date => {
    return (this.props.events || []).filter(event => {
      return (
        event &&
        event._id &&
        event.start_date &&
        event.end_date &&
        moment(event.start_date).isSame(date, "day") &&
        moment(event.end_date).isAfter(moment()) &&
        !event.visit_id &&
        !event.not_planned &&
        !computeIfIsVacation(event)
      );
    });
  };

  handleMoveDayEvents = () => {
    if (!this.state.moveTargetDate) {
      Modal.error({
        title: "",
        content: "Veuillez sélectionner une date d'arrivée."
      });
      return;
    }

    if (!this.state.moveSourceDate) {
      Modal.error({
        title: "",
        content: "Veuillez sélectionner la journée à déplacer."
      });
      return;
    }

    this.setState({ isMovingDayEvents: true });
    this.props.moveDayEvents(this.state.moveSourceDate, this.state.moveTargetDate);
  };

  updateEvents() {
    const luccaVacationDays = this.props.luccaVacationDays || [];
    const calendarEvents = [...this.props.events, ...getLuccaVacationEvents(luccaVacationDays)];
    const isLuccaVacationDay = dayStr => luccaVacationDays.some(vacationDay => vacationDay.date === dayStr);
    const tagLuccaVacationDay = dayStr => {
      if (!isLuccaVacationDay(dayStr)) return;
      $("#calendar")
        .find('.fc-bg td[data-date="' + dayStr + '"], .fc-day[data-date="' + dayStr + '"]')
        .addClass(LUCCA_VACATION_DAY_CLASS);
    };
    const customButtons = {
      planifier: {
        text: "Planifier",
        click: () => {
          this.setState({
            visibleCreationModal: true,
            updateEventFromCalendarClick: false,
            createFromCalendarClick: false,
            eventInfos: {}
          });
        }
      },
      deplacerJournee: {
        text: "Déplacer la journée",
        click: () => {
          const sourceDate = moment(this.props.selectedDate).startOf("day");

          this.setState({
            visibleMoveDayModal: true,
            moveSourceDate: sourceDate,
            moveTargetDate: sourceDate.clone().add(1, "day")
          });
        }
      },
      carte: {
        text: "Planifier via la carte",
        click: () => {
          this.props.setDisplayMode("map");
        }
      }
    };
    if (this.props.isMyPlanning) {
    }

    $("#calendar").fullCalendar("destroy");
    $("#calendar").fullCalendar({
      customButtons,
      // lazyFetching: true,
      theme: false,
      timezone: "local",
      locale: "fr",
      defaultView: this.state.calendarView,
      weekNumbers: true,
      //weekNumbersWithinDays: true,
      weekNumberTitle: "S",
      header: {
        left: `planifier,deplacerJournee,carte,vacation${this.props.isAtLeastManager ? ",absence" : ""}`,
        center: "title",
        right: "month,agendaWeek,agendaDay,list prev,today,next"
      },
      buttonText: {
        today: "Aujourd'hui",
        month: "Mois",
        week: "Semaine",
        day: "Jour",
        list: "Liste"
      },
      eventBackgroundColor: "#fff",
      eventBorderColor: "#ddd",
      eventTextColor: "#515151",
      navLinks: false,
      eventLimit: false,
      allDaySlot: false,
      minTime: getMinTime({ events: this.props.events }),
      maxTime: getMaxTime({ events: this.props.events }),
      defaultDate: this.props.selectedDate,
      agendaEventMinHeight: 20,
      editable: true,
      dayOfMonthFormat: "ddd D/M",
      // eventDurationEditable: false,
      noEventsMessage: "Aucun PDC planifié ce jour.",
      eventOverlap: false,

      dayRender: function(date, cell) {
        var check = $.fullCalendar.formatDate(date, "YYYY-MM-DD");

        if (isJourFerie(check)) {
          cell.addClass("fc-ferie");
          // Manually target agendaWeek & agendaDay items to apply css class
          var $td = $('div.fc-bg > table > tbody > tr > td[data-date="' + date.format("YYYY-MM-DD") + '"]');
          $td.addClass("fc-ferie");
        }

        if (isLuccaVacationDay(check)) {
          cell.addClass(LUCCA_VACATION_DAY_CLASS);
          tagLuccaVacationDay(date.format("YYYY-MM-DD"));
        }
      },
      eventResize: (event, delta, revertFunc, jsEvent, ui, view) => {
        if (event.end >= moment())
          this.props.sendUpdatedEvent(
            {
              client_id: event.client_id,
              sector_id: event.sector_id,
              pdc_id: event.pdc_id,
              user_id: event.user_id,
              end_date: event.end.format(),
              start_date: event.start.format(),
              event_type_id: event.event_type_id,
              rdv: event.rdv,
              _id: event._id
            },
            "drag"
          );
        else revertFunc();
      },
      eventDrop: (event, delta, revertFunc, jsEvent, ui, view) => {
        if (isLuccaVacationEvent(event)) {
          revertFunc();
          return;
        }

        if (
          moment(event.start).isAfter(moment()) &&
          moment(event.start_date).isBefore(
            moment()
              .subtract(1, "days")
              .endOf("day")
              .toString()
          )
        ) {
          this.props.sendNewEvent({
            client_id: event.client_id,
            sector_id: event.sector_id,
            pdc_id: event.pdc_id,
            user_id: event.user_id,
            end_date: event.end.format(),
            start_date: event.start.format(),
            event_type_id: event.event_type_id,
            rdv: event.rdv,
            _id: event._id
          });
          revertFunc();
        } else if (
          moment(event.start).isAfter(moment()) &&
          moment(event.start_date).isAfter(
            moment()
              .subtract(1, "days")
              .endOf("day")
              .toString()
          )
        ) {
          this.props.sendUpdatedEvent(
            {
              client_id: event.client_id,
              sector_id: event.sector_id,
              pdc_id: event.pdc_id,
              user_id: event.user_id,
              end_date: event.end.format(),
              start_date: event.start.format(),
              event_type_id: event.event_type_id,
              rdv: event.rdv,
              _id: event._id
            },
            "drag"
          );
        } else revertFunc();
      },
      eventRender: (event, element, view) => {
        if (isLuccaVacationEvent(event)) {
          $(element)
            .addClass(LUCCA_VACATION_EVENT_CLASS)
            .attr("title", `${moment(event.start).format("DD/MM/YYYY")} : ${LUCCA_VACATION_EVENT_TITLE}`);
          return;
        }

        // Check event status (visite, non visite, planifie, non planifie, rdv)
        isVisited(event) ? $(element).addClass("p-calendar-event-visite") && $(element).attr("type", "visite") : null;
        isPlaned(event)
          ? $(element).addClass("p-calendar-event-planifie") && $(element).attr("type", "planifie")
          : null;
        isNotPlanned(event)
          ? $(element).addClass("p-calendar-event-non-planifie") && $(element).attr("type", "non-planifie")
          : null;
        isNotVisited(event)
          ? $(element).addClass("p-calendar-event-non-visite") && $(element).attr("type", "non-visite")
          : null;
        event.event_sous_type_label === "animation" ? $(element).addClass("p-calendar-event-animation") : null;
        isSpeedyOrAdmin(event)
          ? $(element)
              .find(".fc-title")
              .text("SPEEDY/ADMIN")
              .addClass("p-calendar-event-speedy")
          : null;
        event.rdv === true ? $(element).addClass("p-calendar-event-rdv") && $(element).attr("rdv", "true") : null;
        if (isDurationLowerThan45Min(event)) {
          $(element).addClass("fc-short");
          const shortTimeEvents = $(element).find("[data-start]");
          for (let i = 0; shortTimeEvents && i < shortTimeEvents.length; i++) {
            shortTimeEvents[i].style.display = "none";
          }
        }

        isVacationPending(event)
          ? $(element).addClass("p-calendar-event-non-visite") && $(element).attr("type", "non-visite")
          : null;

        isVacationRejected(event)
          ? $(element).addClass("p-calendar-event-non-planifie") && $(element).css("display", "none")
          : null;

        isVacationValidated(event)
          ? $(element).addClass("p-calendar-event-visite") && $(element).attr("type", "visite")
          : null;
        // Check visit type and add icon
        this.getEventType(element, event.visitType);
        if (view.name === "month") {
          $(element).attr("date-num", event.start.format("YYYY-MM-DD"));
          $(element).css("display", "none");
        }

        element.attr(
          "title",
          `${moment(event.start_date).format("HH:mm")}-${moment(event.end_date).format("HH:mm")} : ${
            event.pdc_label
          } (${event.event_type_label} : ${event.event_sous_type_label})`
        );
        return;
      },
      eventAfterAllRender: function(view) {
        // Tag public holidays (jours fériés) so they get the grey "days off" styling.
        // dayRender does not reliably reach the agenda time-grid background column for
        // weekday holidays, so re-apply the class here once the full grid is rendered.
        for (let day = view.start.clone(); day.isBefore(view.end); day.add(1, "day")) {
          var dayStr = day.format("YYYY-MM-DD");
          if (isJourFerie(dayStr)) {
            $("#calendar")
              .find('.fc-bg td[data-date="' + dayStr + '"], .fc-day[data-date="' + dayStr + '"]')
              .addClass("fc-ferie");
          }
          tagLuccaVacationDay(dayStr);
        }
        // If month view, render events with numbers
        if (view.name === "month") {
          for (let cDay = view.start.clone(); cDay.isBefore(view.end); cDay.add(1, "day")) {
            var dateNum = cDay.format("YYYY-MM-DD");
            var dayEl = $('.fc-day[data-date="' + dateNum + '"]');
            // Count planifiés events
            var planifieCount = $('.fc-event[date-num="' + dateNum + '"][type=planifie]').length;
            // Count non planifiés events
            var nonPlanifieCount = $('.fc-event[date-num="' + dateNum + '"][type=non-planifie]').length;
            // Count visités events
            var visiteCount = $('.fc-event[date-num="' + dateNum + '"][type=visite]').length;
            // Count non visités events
            var nonVisiteCount = $('.fc-event[date-num="' + dateNum + '"][type=non-visite]').length;
            // Count rdv events
            var rdvCount = $('.fc-event[date-num="' + dateNum + '"][rdv=true]').length;

            // Render
            if (planifieCount || nonPlanifieCount || visiteCount || nonVisiteCount || rdvCount) {
              const planifies =
                planifieCount !== 0
                  ? '<span class="p-calendar-event-count p-calendar-event-count-planifie">' +
                    planifieCount +
                    " planifié(s)" +
                    "</span>"
                  : "";
              const nonPlanifies =
                nonPlanifieCount !== 0
                  ? '<span class="p-calendar-event-count p-calendar-event-count-non-planifie">' +
                    nonPlanifieCount +
                    " non planifié(s)" +
                    "</span>"
                  : "";
              const visites =
                visiteCount !== 0
                  ? '<span class="p-calendar-event-count p-calendar-event-count-visite">' +
                    visiteCount +
                    " visité(s)" +
                    "</span>"
                  : "";
              const nonVisites =
                nonVisiteCount !== 0
                  ? '<span class="p-calendar-event-count p-calendar-event-count-non-visite">' +
                    nonVisiteCount +
                    " non visité(s)" +
                    "</span>"
                  : "";
              const rdvs =
                rdvCount !== 0
                  ? '<span class="p-calendar-event-count p-calendar-event-count-rdv">' +
                    rdvCount +
                    " rdv(s)" +
                    "</span>"
                  : "";
              const html =
                '<div class="p-calendar-event-count-container">' +
                planifies +
                nonPlanifies +
                visites +
                nonVisites +
                rdvs +
                "</div>";
              dayEl.append(html);
            }
          }
        }
      },
      showNonCurrentDates: false,
      viewRender: (view, element) => {
        const { endMs, startMs } = view.dateProfile.activeUnzonedRange;
        this.setState({ calendarView: view.name });
        let endMsCorrected = moment(view.end.clone());
        let startMsCorrected = moment(view.start.clone());
        if (view.name === "agendaWeek") {
          endMsCorrected = moment(startMs).endOf("week");
        } else if (view.name === "agendaDay" || view.name === "list") {
          endMsCorrected = moment(startMs).endOf("day");
        } else if (view.name === "month") {
          startMsCorrected = moment(startMs).startOf("month");
          endMsCorrected = moment(startMs).endOf("month");
        }
        this.props.updateCurrentDateRange(startMs, endMsCorrected);
      },
      // eventMouseover: (event, jsEvent, view) => {},
      dayClick: (date, jsEvent, view) => {
        // If month view, go to day view
        if (view.name === "month") {
          $("#calendar").fullCalendar("changeView", "agendaDay");
          $("#calendar").fullCalendar("gotoDate", date);
        }
        this.props.updateSelectedDate(date);

        // If week/day view, add new planning item
        if (view.name === "agendaWeek" || view.name === "agendaDay") {
          // MODALE D'AJOUT AVEC DATE DE DÉBUT (+ date de fin = date + 30min)
          if (date >= moment())
            this.setState({
              visibleCreationModal: true,
              createFromCalendarClick: true,
              updateEventFromCalendarClick: false,
              eventInfos: { dateEvent: date, start_date: date }
            });
        }
      },

      eventClick: (calEvent, jsEvent, view) => {
        if (isLuccaVacationEvent(calEvent)) {
          this.props.updateSelectedDate(calEvent.start);
          return;
        }

        const isVacationEvent = computeIfIsVacation(calEvent);

        this.setState({
          visibleCreationModal: !isVacationEvent,
          updateEventFromCalendarClick: true,
          createFromCalendarClick: false,
          eventInfos: calEvent
        });
        this.props.updateSelectedDate(calEvent.start);
      },
      events: calendarEvents,
      slotLabelFormat: "HH:mm",
      contentHeight: "auto",
      timeFormat: "HH:mm"
      // displayEventTime: false
      // displayEventEnd: false
    });
  }

  render() {
    const moveSourceDate = this.state.moveSourceDate || moment(this.props.selectedDate).startOf("day");
    const movableEventsCount = this.getMovableEventsOfDay(moveSourceDate).length;
    const isMoveDayLoading = this.state.isMovingDayEvents && this.props.modalIsLoading;
    const infoModal = requestResponse => {
      const modalType = {
        0: "error",
        1: "success"
      };

      Modal[modalType[requestResponse.status]]({
        title: "",
        content: <div>{requestResponse.text}</div>
      });
    };

    return (
      <Fragment>
        <EventForm
          isToBeModified={this.state.updateEventFromCalendarClick}
          visibleCreationModal={this.state.visibleCreationModal}
          eventInfos={this.state.eventInfos}
          updateEventFromCalendarClick={this.state.updateEventFromCalendarClick}
          createFromCalendarClick={this.state.createFromCalendarClick}
          changeVisibleCreationModal={() =>
            this.setState({
              visibleCreationModal: false
            })
          }
          requestResponseModal={infoModal}
        />
        <Modal
          visible={this.state.visibleMoveDayModal}
          title="Déplacer la journée"
          onOk={this.handleMoveDayEvents}
          onCancel={() => {
            if (!isMoveDayLoading) {
              this.setState({ visibleMoveDayModal: false, moveSourceDate: undefined, moveTargetDate: undefined });
            }
          }}
          okText="Déplacer"
          cancelText="Annuler"
          confirmLoading={isMoveDayLoading}
          closable={!isMoveDayLoading}
          maskClosable={!isMoveDayLoading}
          okButtonProps={{ disabled: movableEventsCount === 0 || isMoveDayLoading }}
          cancelButtonProps={{ disabled: isMoveDayLoading }}
        >
          <Spin spinning={isMoveDayLoading} tip="Déplacement des événements...">
            <p>{`${movableEventsCount} événement(s) planifié(s), non visité(s) et à venir seront déplacé(s).`}</p>
            <div className="p-mrg-bot-s">
              <div className="p-mrg-bot-xs">Journée à déplacer</div>
              <DatePicker
                allowClear={false}
                format="DD/MM/YYYY"
                value={moveSourceDate}
                disabled={isMoveDayLoading}
                disabledDate={current => current && current < moment().startOf("day")}
                onChange={moveSourceDate => {
                  const nextSourceDate = moveSourceDate && moveSourceDate.startOf("day");
                  this.setState(state => ({
                    moveSourceDate: nextSourceDate,
                    moveTargetDate:
                      !state.moveTargetDate || moment(state.moveTargetDate).isSame(nextSourceDate, "day")
                        ? nextSourceDate && nextSourceDate.clone().add(1, "day")
                        : state.moveTargetDate
                  }));
                }}
              />
            </div>
            <div>
              <div className="p-mrg-bot-xs">Déplacer vers</div>
              <DatePicker
                allowClear={false}
                format="DD/MM/YYYY"
                value={this.state.moveTargetDate}
                disabled={isMoveDayLoading}
                disabledDate={current =>
                  current &&
                  (current < moment().startOf("day") ||
                    (this.state.moveSourceDate && current.isSame(this.state.moveSourceDate, "day")))
                }
                onChange={moveTargetDate => this.setState({ moveTargetDate })}
              />
            </div>
          </Spin>
        </Modal>

        {this.props.displayMode === "map" && (
          <div className="p-pdg-bot">
            <a
              style={{ color: "#515151", fontStyle: 12 }}
              onClick={() => {
                this.props.setDisplayMode("calendar");
              }}
            >
              <span className="icon-arrow-left p-mrg-right-s" style={{ color: "#515151" }} />
              Retour vers le calendrier
            </a>
          </div>
        )}
        {this.props.displayMode === "calendar" ? (
          <div className="p-mrg-bot-l" id="calendar" />
        ) : (
          <MapContainer
            displayEventCreationModal={() => {
              this.setState({ visibleCreationModal: true, updateEventFromCalendarClick: false });
            }}
            updateCurrentDateRange={this.props.updateCurrentDateRange}
          />
        )}
      </Fragment>
    );
  }
}
const mapStateToProps = state => {
  const roleId = selectUserRoleId(state);
  const isAtLeastManager = roleId <= roles.MANAGER;
  const connectedUserInfos = selectUserInfos(state);
  const selectedPlanningEmail = selectPlanningEmail(state);

  const isMyPlanning = connectedUserInfos.email === selectedPlanningEmail;

  const events = selectEvents(state);
  const vacations = selectPresenceSelectedUserVacations(state);
  const luccaVacationDays = selectLuccaVacationDays(state);
  return {
    isAtLeastManager,
    isMyPlanning,
    events: [...events, ...vacations],
    luccaVacationDays,
    selectedDate: selectPlanningDate(state),
    modalIsLoading: state.planning.modalIsLoading,
    requestResponse: state.planning.requestResponse
  };
};
const mapDispatchToProps = dispatch => {
  return {
    fetchtypesVisitList: () => dispatch(fetchtypesVisitList()),
    getEventTypesList: () => dispatch(fetchEventTypesList()),
    sendUpdatedEvent: (event, updateMethod) => dispatch(sendUpdatedEvent(event, updateMethod)),
    sendNewEvent: event => dispatch(sendNewEvent(event)),
    moveDayEvents: (sourceDate, targetDate) => dispatch(moveDayEvents(sourceDate, targetDate)),
    updateSelectedDate: date => dispatch(setPlanningSelectedDate(date))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FullCalendar);



// WEBPACK FOOTER //
// src/containers/activite/planning/Calendar.js